import React from 'react';
import { DatePicker, Spin } from 'antd';

import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';

import CurrentRoleStore from '../../stores/CurrentRoleStore';

import AttendanceCalendar from '../share/AttendanceCalendar';

import moment from 'moment';
import locale from 'antd/lib/date-picker/locale/zh_CN';

export default class StudentAttendanceRercordClassDetailPage extends React.Component {
  constructor(props) {
    super(props);

    let date = new Date();
    let currentDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

    this.state = {
      semester: SharedTools.getCurrentSemester(),
      currentRole: CurrentRoleStore.getCurrentRole(),
      setAttendance: false,
      editAttendance: false,
      loading: false,
      currentDate: moment(currentDate, 'YYYY-MM-DD').toDate(),
      classId: props.params.classId,
      students: []
    }

    this.onDateChange = this.onDateChange.bind(this)

  }

  componentWillReceiveProps(newProps) {

  }

  componentDidMount() {
    let date = new Date(this.state.currentDate)
    let data = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
      class_id: this.state.classId
    }
    this.getClassDetailAttendance(data)

  }

  onDateChange(day, dateString) {
    let date = new Date(dateString)
    let data = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
      class_id: this.state.classId
    }
    this.setState({
      currentDate: dateString
    })
    this.getClassDetailAttendance(data)
  }

  getClassDetailAttendance(data) {
    DataService.getClassDetailAttendance(data).then(res => {
      console.log(res)
      this.setState({
        students: res,
      })
    }, (error) => {
      console.log(error);
      this.setState({
        loading: false,
      })
    })
  }

  // componentWillUnmount() {
  //   CurrentRoleStore.removeChangeListener(this.onRolesChange);
  // }

  render() {
    let students = this.state.students;
    return (
      <div className="student-attendance-rercord-class-detail-page">
        <DatePicker onChange={this.onDateChange} locale={locale} allowClear={false} defaultValue={moment(this.state.currentDate, 'YYYY-MM-DD')} placeholder="" className="date-picker-container" />
        <Spin spinning={this.state.loading}>
          <div className="attendance-class-detail-modal">
            <div className="attendance-class-detail-container">
              <div className="students-container">
                <div className="container-header">未到{students.absence ? students.absence.length : 0}人</div>
                <div className="students-list">
                  {students.absence ? students.absence.map((student) =>
                    <div className="student-name" key={student.id}>{student.full_name}</div>
                  ) : ''}
                </div>
              </div>
              <div className="students-container">
                <div className="container-header">已到{students.on_duty ? students.on_duty.length : 0}人</div>
                <div className="students-list">
                  {students.on_duty ? students.on_duty.map((student) =>
                    <div className="student-name" key={student.id}>{student.full_name}</div>
                  ) : ''}
                </div>
              </div>
            </div>
          </div>
        </Spin>
        {/* <AttendanceCalendar semester={this.state.semester} setAttendance={this.state.setAttendance} editAttendance={this.state.editAttendance} /> */}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/attendance/StudentAttendanceRercordClassDetailPage.jsx